/** TanStack Query persister on IndexedDB (spec §8.4: server data readable offline). */
import type { PersistedClient, Persister } from "@tanstack/query-persist-client-core";
import { getMeta, setMeta } from "../sync/persistence";

const KEY = "tanstack-query-cache";

export const idbPersister: Persister = {
  persistClient: async (client: PersistedClient) => {
    await setMeta(KEY, client);
  },
  restoreClient: async () => (await getMeta<PersistedClient>(KEY)) ?? undefined,
  removeClient: async () => {
    await setMeta(KEY, undefined);
  },
};

export const PERSIST_MAX_AGE = 1000 * 60 * 60 * 24 * 30;
/** Query GC must stay below the ~24.8-day setTimeout limit or it fires immediately. */
export const GC_TIME = 1000 * 60 * 60 * 24 * 7;
